import React from "react";
import { createRoot } from "react-dom/client";

import {
  AuthenticationResult,
  EventMessage,
  EventType,
  PublicClientApplication,
} from "@azure/msal-browser";

import "../sentry.config.js";

import Application from "./components/Application/Application";
import msalConfig from "./components/Application/authConfiguration/msalConfig";

export const msalInstance = new PublicClientApplication(msalConfig);

msalInstance.initialize().then(() => {
  const accounts = msalInstance.getAllAccounts();
  if (accounts.length > 0) {
    msalInstance.setActiveAccount(accounts[0]);
  }

  msalInstance.addEventCallback((event: EventMessage) => {
    if (event.eventType === EventType.LOGIN_SUCCESS && event.payload) {
      const payload = event.payload as AuthenticationResult;
      const account = payload.account;
      msalInstance.setActiveAccount(account);
    }
  });

  const container = document.getElementById("@licentiekantoor/front-end");
  if (container) {
    const root = createRoot(container);
    root.render(<Application pca={msalInstance} />);
  }
});
